import { PropsWithChildren, useState } from 'react';
import { Envs, Scripts, useBaseUrl, useEnvContext } from 'scbk-services';

const baseUrl = window.location.origin;
const nfilterScripts = [
  {
    id: 'open-nfilter',
    src: `${baseUrl}/resource/product/nshc/OpenWebNFilter/js/open_nFilter.js`,
  },
  {
    id: 'nfilter',
    src: `${baseUrl}/resource/product/nshc/OpenWebNFilter/js/nFilter.js`,
  },
  {
    id: 'secretUtil',
    src: `${baseUrl}/resource/product/nshc/OpenWebNFilter/js/secretUtil.js`,
  },
];

/**
 *
 * @param param0
 * @returns
 */
const VirtualKeypadProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [ready, setReady] = useState(false);
  const { getEnv } = useEnvContext();
  const { getBsoiBaseUrl } = useBaseUrl();
  const contextBaseUrl = getBsoiBaseUrl(getEnv() === Envs.MOCK);

  const init = () => {
    Object.assign(window.nshc, {
      contextPath: `${contextBaseUrl}`,
      CSSPath: '/resource/product/nshc/OpenWebNFilter/css',
      imgPath: '/resource/product/nshc/OpenWebNFilter/image',
      randomIdLength: '10',
      serviceNameKeypadManager: 'NFilterKeypadManager',
      algName: 'ECDH',
      keyLength: '2048',
      uuSessionUse: true,
      NSCryptoUse: false,
    });

    window.nshc.setScreenReaderUse(true);
  };

  if (!ready) {
    return (
      <>
        <Scripts
          scripts={nfilterScripts}
          strategy="afterInteractive"
          onReady={() => {
            init();
            setReady(true);
          }}
          onError={(e: Error) => {
            console.error('[VirtualKeypadProvider] nfilter load failed', e);
          }}
        />
      </>
    );
  }
  return <>{children}</>;
};

export { VirtualKeypadProvider };
